//积分形式
export var integralFormEnum = [{
  label: '全员发放',
  value: 1
}, {
  label: '全员回收',
  value: 2
}, {
  label: '指定员工发放',
  value: 3
}, {
  label: '指定员工回收',
  value: 4
}];